import { useCallback, useState } from "react";
import getWindow from "../utils/window";
import useMatchMedia from "./useMatchMedia";
import { DEFAULT_DEVICE_PIXEL_RATIO } from "../utils/zoomMath";

const readDevicePixelRatio = (): number =>
  getWindow()?.devicePixelRatio || DEFAULT_DEVICE_PIXEL_RATIO;

export default function useDevicePixelRatio(): number {
  const [devicePixelRatio, setDevicePixelRatio] = useState<number>(
    DEFAULT_DEVICE_PIXEL_RATIO,
  );

  const handleChange = useCallback(
    (): void => setDevicePixelRatio(readDevicePixelRatio()),
    [],
  );

  useMatchMedia(`(resolution: ${devicePixelRatio}dppx)`, handleChange);

  return devicePixelRatio;
}
